###!
 *  Bits from underscore.js
 *
 *  http://underscorejs.org
 *  (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 *  Underscore may be freely distributed under the MIT license.
###


# A (possibly faster) way to get the current timestamp as an integer.
now = Date.now || ->
  new Date().valueOf()


# Returns a function, that, as long as it continues to be invoked, will not
# be triggered. The function will be called after it stops being called for
# N milliseconds. If `immediate` is passed, trigger the function on the
# leading edge, instead of the trailing.
debounce = (fun, wait, immediate)->
  timeout   = null
  args      = null
  context   = null
  timestamp = null
  result    = null

  later = ->
    last = now() - timestamp

    if last < wait && last >= 0
      timeout = setTimeout later, wait-last
    else
      timeout = null
      unless immediate
        result = fun.apply context, args
        context = args = null unless timeout

  return ->
    context = this
    args = arguments
    timestamp = now()

    callNow = immediate && !timeout
    timeout = setTimeout(later, wait) unless timeout
    if callNow
      result = fun.apply(context, args)
      context = args = null
    return result

window.debounce = debounce
